import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'

const Divider = styled.div<{ mode: Theme }>`
  height: 1px;
  margin: 4px 0;
  background-color: ${({ mode }) => sys[mode].common.divider[100]};
`

export default Divider
